export default __webpack_public_path__ + "static/calzaretta-b4535da01fb43cf517acd4d92873c8fc.jpg";